
// Re-export all payment-related services and types
import { Payment, CheckoutSessionOptions, OneTimePaymentOptions } from './types';
import { PaymentRetrievalService } from './paymentRetrievalService';
import { PaymentCreationService } from './paymentCreationService';

// Create a combined PaymentService object with all methods
export const PaymentService = {
  // From PaymentRetrievalService
  getPaymentsForFamily: PaymentRetrievalService.getPaymentsForFamily,
  getPaymentsForOrganization: PaymentRetrievalService.getPaymentsForOrganization,
  getPaymentById: PaymentRetrievalService.getPaymentById,
  getFamilyPayments: PaymentRetrievalService.getFamilyPayments,
  getRecentPayments: PaymentRetrievalService.getRecentPayments,
  clearCache: PaymentRetrievalService.clearCache, // Add this method to export it
  
  // From PaymentCreationService
  createPayment: PaymentCreationService.createPayment,
  createCheckoutSession: PaymentCreationService.createCheckoutSession,
  createOneTimePayment: PaymentCreationService.createOneTimePayment,
};

// Export individual services for direct usage
export { PaymentRetrievalService, PaymentCreationService };

// Export types using 'export type' syntax for isolatedModules
export type { Payment, CheckoutSessionOptions, OneTimePaymentOptions };

// Export PaymentService as default export for backward compatibility
export default PaymentService;
